module.exports = __webpack_public_path__ + "static/media/7.bfa34e1d.jpg";